// extracted by mini-css-extract-plugin
export default {"commentBox":"J3den4","withPadding":"Qp8sMy"};